export const isBrowserIE = () => {
  if (!global.window || !global.window.navigator) {
    return false;
  }
  const sAgent = global.window.navigator.userAgent;
  const Idx = sAgent.indexOf("MSIE");

  if (Idx > -1) {
    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)), 10);
  } else if (!!sAgent.match(/Trident\/7\./) || sAgent.indexOf("Edge") > -1) {
    return 11;
  }
  return false;
};

export const isBrowserUC = () => {
  if (!global.window) {
    return false;
  }

  const sAgent = global.window.navigator.userAgent;
  return sAgent.indexOf("UCBrowser") > -1;
};

export const isBrowserQQ = () => {
  if (!global.window) {
    return false;
  }

  let cV = global.navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
  cV = cV ? parseInt(cV[2], 10) : false;

  const qq = global.navigator.userAgent.match(
    /Mobile\/\w{5,}\sQQ\/(\d+[.\d]+)/
  );
  const width = global.window.innerWidth < 780;

  if ((cV < 45 || qq) && width) {
    return true;
  }
  return false;
};

export const isBrowserWechat = () =>
  global.navigator.userAgent.indexOf("MicroMessenger") !== -1;
